import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { URLRETURNS, URLRETURNSLABEL } from '../config/setup/setup';
import httpCommonHeaders from '../helpers/httpCommonHeaders';
import { prepareToOpenPdf } from '../helpers/pdf';

export const submitReturnsForm = async ({ orderLineId, details }) => {
  const response = await axios({
    data: {
      returnsDetails: details,
    },
    headers: httpCommonHeaders(),
    method: 'POST',
    responseType: 'arraybuffer',
    url: `${URLRETURNS}/${orderLineId}`,
    validateStatus: (status) => {
      return status < 500;
    },
    withCredentials: true,
  });

  return prepareToOpenPdf(response?.data);
};

export const retreiveReturnsLabelPdf = async ({ orderLineId, details }) => {
  const response = await axios({
    data: {
      returnsPdf: details,
    },
    headers: httpCommonHeaders(),
    method: 'POST',
    responseType: 'arraybuffer',
    url: `${URLRETURNSLABEL}/${orderLineId}`,
    validateStatus: (status) => {
      return status < 500;
    },
    withCredentials: true,
  });

  return prepareToOpenPdf(response?.data);
};
